import Carousel from './Carousel';
import React, { useEffect, useState } from 'react';
import styles from './styles/publications_and_patents.module.scss';
import json_publications_and_patents_en from './jsons/en/publications_and_patents_en.json';
import json_publications_and_patents_pt from './jsons/pt/publications_and_patents_pt.json';

const PublicationsAndPatents = () => {

    const [language, set_language] = useState(localStorage.getItem("language"));

    const json_data = language === "EN"
        ? json_publications_and_patents_en
        : json_publications_and_patents_pt;

    const [can_render_carousel, set_can_render_carousel] = useState(false);

    useEffect(() => {

        set_can_render_carousel(true);

        const handleLanguageChange = () => {
            set_language(localStorage.getItem("language"));
        };

        window.addEventListener('language', handleLanguageChange);

        return () => {
            window.removeEventListener('language', handleLanguageChange);
        };

    }, []);

    return (
        <div className={styles.root}>

            <div className={styles.suptitle}>
                {json_data.suptitle}
            </div>

            <div className={styles.root_background_fade} />

            {/* Carousel original com todos os itens */}
            <Carousel
                type={"alternative"}
                data={json_data}
                can_render_carousel={can_render_carousel}
                background_color={"rgba(150, 150, 150, 0.3)"}
            />

            {/* Patentes em destaque */}
            {json_data.featured_items && (
                <div className={styles.static_container}>

                    {json_data.featured_items.map((item, index) => (

                        <div
                            key={index}
                            className={styles.static_card}
                        >

                            <div
                                className={styles.static_image}
                                style={{
                                    backgroundImage: `url(${require(`${item[1]}`)})`,
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "contain"
                                }}
                            />

                            <div
                                className={styles.static_title}
                                dangerouslySetInnerHTML={{
                                    __html: item[0]
                                }}
                            />

                            <a
                                href={item[2]}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.static_button}
                            >
                                {json_data.button_text}
                            </a>

                        </div>

                    ))}

                </div>
            )}

        </div>
    );
}

export default PublicationsAndPatents;